var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentAmount = function SvgPaymentAmount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.5 12a10 10 0 1 0 20 0 10 10 0 0 0-20 0M5.5 5l2 2m12 12-2-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.423 16.03c-.439.184-.91.278-1.385.278a3.99 3.99 0 0 1-3.807-4.154A3.99 3.99 0 0 1 13.038 8c.386.002.768.063 1.136.18M7.5 10.769h4.154M7.5 13.539h4.154"
  })));
};
export default SvgPaymentAmount;